<apx-chart #pieChart *ngIf="chartOptions"
           [chart]="chartOptions.chart"
           [colors]="chartOptions.colors"
           [labels]="chartOptions.labels"
           [plotOptions]="chartOptions.plotOptions"
           [series]="chartOptions.series"
           [states]="chartOptions.states"
           [tooltip]="chartOptions.tooltip"></apx-chart>
